module.exports = __webpack_public_path__ + "static/media/cid10.f8bb60f4.svg";